import React from "react";
import { Image, Transition } from "semantic-ui-react";

const Me = props => {
  return <Image fluid src="https://picsum.photos/id/1/5616/3744" rounded />;
};

export default Me;
